/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import LoadingSkeleton from 'bundles/grading/components/common/LoadingSkeleton';

const styles = {
  leftContainer: css`
    display: inherit;
    align-items: center;
    overflow-y: hidden;
    margin-right: auto;
  `,
};

// Component for Top Bar sub components for SGA
const LazyLoadLeft = () => {
  return <LoadingSkeleton width="25vw" height="30px" cssOverride={styles.leftContainer} />;
};

export default LazyLoadLeft;
